module.exports = "<!--<div class=\"select\">\n  <select class=\"form-control\" [formControl]=\"statusCtrl\">\n    <option *ngFor=\"let status of statuses\" [value]=\"status.value\">{{ status.label }}</option>\n  </select>\n</div>\n-->\n\n<clr-checkbox *ngFor=\"let status of availableStatuses\" [clrChecked]=\"isChecked(status.value)\"\n              (clrCheckedChange)=\"setStatus(status.value, $event)\">\n  <cw-project-status [status]=\"status.value\"></cw-project-status>\n</clr-checkbox>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/list/status-filter/status-filter.component.html
// module id = ./src/app/projects/list/status-filter/status-filter.component.html
// module chunks = main